/**
 * Bundle sticky redirect — Monster Cart sticky ATC bar fix per prodotti bundle.
 *
 * Monster Cart sticky bar (.mu_sticky_mobile_atc) su PDP mobile manda POST
 * /cart/add.js con payload nudo {quantity, id}, ignorando il form Simple Bundles
 * del PDP. Risultato: ordine bundle incompleto (revenue loss ~35€/ordine).
 *
 * Sui prodotti bundle questo script:
 *   1. Ri-etichetta la sticky bar come mirror dello stato del bottone ATC del
 *      PDP principale: "Aggiungi al carrello" se disponibile, "Esaurito" se
 *      disabled o testo OOS. Lo stato è letto live dal bottone PDP, non è
 *      hardcoded, per coprire il caso bundle soldout (componenti OOS).
 *   2. Intercetta il tap in capture phase. Se disponibile, fa click sintetico
 *      immediato sul bottone ATC principale del PDP, che ha già il fix
 *      dispatchEvent('change') (12/5/2026 in sections/main-product.liquid:1979).
 *      Se OOS, no-op (preventDefault soltanto): la sticky è disabilitata
 *      visivamente e il tap non scatena POST né apertura drawer.
 *
 * Detection bundle via marker DOM [name="properties[_bundle_selection]"], cached
 * al load (il marker è statico in vita pagina). Resiliente al refactor SKU prefix
 * kit- → metafield custom.is_bundle (tech-debt task aperta).
 *
 * Pattern AgenticOS Bug Fix End-to-End — sessione 13/5/2026 (iter sticky OOS).
 */
(function () {
  'use strict';

  const PLACEHOLDER_TEXT = 'Scegli la quantità';
  const AVAILABLE_LABEL = 'Aggiungi al carrello';
  const OOS_LABEL = 'Esaurito';
  const MAIN_BTN_SELECTOR = 'product-form form[action*="/cart/add"] button[name="add"]';

  let _isBundle = false;
  function isBundleProduct() {
    if (_isBundle) return true;  // sticky cache positiva
    const form = document.querySelector('product-form form[action*="/cart/add"]');
    if (form?.querySelector('[name="properties[_bundle_selection]"]')) {
      _isBundle = true;
      return true;
    }
    return false;
  }

  // Legge stato del bottone ATC principale del PDP. Ignora il bottone secondario
  // "Avvisami quando torna disponibile" (app back-in-stock) — quello non risponde
  // a [name="add"], quindi il selettore lo esclude naturalmente.
  function getPdpAtcState() {
    const mainBtn = document.querySelector(MAIN_BTN_SELECTOR);
    if (!mainBtn) return { available: true, label: AVAILABLE_LABEL };

    const disabled =
      mainBtn.disabled ||
      mainBtn.hasAttribute('disabled') ||
      mainBtn.getAttribute('aria-disabled') === 'true';

    const text = (mainBtn.textContent || '').trim();
    const oosMatch = /esaurito|sold\s*out/i.test(text);

    if (disabled || oosMatch) {
      return { available: false, label: OOS_LABEL };
    }
    return { available: true, label: AVAILABLE_LABEL };
  }

  function relabelSticky(stickyAtc) {
    if (!stickyAtc) return;
    if (!isBundleProduct()) return;

    const state = getPdpAtcState();
    const currentLabel = stickyAtc.getAttribute('data-text') || '';
    const currentAvailable = stickyAtc.dataset.available || '';
    const containsPlaceholder = stickyAtc.textContent.includes(PLACEHOLDER_TEXT);

    // Trigger: placeholder Monster Cart riemerso, oppure label/stato divergente
    // da quello che abbiamo scritto noi.
    const needsUpdate =
      containsPlaceholder ||
      currentLabel !== state.label ||
      currentAvailable !== String(state.available);

    if (!needsUpdate) return;

    stickyAtc.setAttribute('data-text', state.label);
    stickyAtc.dataset.available = String(state.available);
    stickyAtc.innerHTML = state.label;

    if (!state.available) {
      stickyAtc.classList.add('mu_sticky_disabled');
      stickyAtc.style.opacity = '0.55';
      stickyAtc.style.cursor = 'not-allowed';
      stickyAtc.style.pointerEvents = '';  // tap deve ancora arrivare al listener
    } else {
      stickyAtc.classList.remove('mu_sticky_disabled');
      stickyAtc.style.opacity = '';
      stickyAtc.style.cursor = '';
      stickyAtc.style.pointerEvents = '';
    }
  }

  function setupRelabelObserver() {
    relabelSticky(document.querySelector('.mu_sticky_mobile_atc'));

    // Observer unico su document.body: cattura sia mutation Monster Cart sulla
    // sticky (data-text, text node concatenati) sia transizioni di stato del
    // bottone PDP principale (disabled, aria-disabled). Tutto converge su
    // relabelSticky() con stato corrente — needsUpdate filtra le no-op.
    const observer = new MutationObserver(function () {
      relabelSticky(document.querySelector('.mu_sticky_mobile_atc'));
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-text', 'disabled', 'aria-disabled']
    });
  }

  // Click handler in capture phase: esegue prima del listener Monster Cart,
  // stopImmediatePropagation lo blocca prima della POST nuda.
  document.addEventListener('click', function (e) {
    const stickyAtc = e.target.closest('.mu_sticky_mobile_atc');
    if (!stickyAtc) return;
    if (!isBundleProduct()) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Bundle OOS: no-op completo. La sticky è già disabilitata visivamente,
    // il tap è bloccato qui senza POST né click sintetico.
    if (stickyAtc.dataset.available === 'false') return;

    const mainBtn = document.querySelector(MAIN_BTN_SELECTOR);
    if (!mainBtn) return;

    // Click sintetico immediato — niente scroll. Il submit del form PDP
    // attiva Monster Cart drawer sopra la sticky.
    mainBtn.click();
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupRelabelObserver);
  } else {
    setupRelabelObserver();
  }
})();
